import {Container, Nav, Navbar} from "react-bootstrap";
import UserMenu from "../header/UserMenu";
import "./TopNavigation.scss";
import {useOktaAuth} from "@okta/okta-react";
import { useState, useEffect } from "react";

function TopNavigation(props) {
    // const { authState, oktaAuth } = useOktaAuth();
    // const [userInfo, setUserInfo] = useState(null);
    // useEffect(() => {
    //     if (!authState || !authState.isAuthenticated) {
    //         // When user isn't authenticated, forget any user info
    //         setUserInfo(null);
    //     } else {
    //         setUserInfo(authState.idToken.claims);
    //         // You can also get user information from the `/userinfo` endpoint
    //         /*oktaAuth.getUser().then((info) => {
    //           setUserInfo(info);
    //         });*/
    //     }
    // }, [authState, oktaAuth]); // Update if authState changes
    return (
      <div className="topnav">
          <Navbar bg="light" expand="lg">
              <Container>
                  <Nav className="me-auto justify-content-end">
                      {/*<Nav.Link as={Link} to='/contact'>Contact</Nav.Link>*/}
                  </Nav>
                  <UserMenu/>
              </Container>
          </Navbar>
      </div>
  );
}

export default TopNavigation;
